import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchSensitive = childId => {
    return RESTClient.getAuthenticatedObservable(`v2/children/${childId}/sensitive`);
};

export const updateSensitive = (childId, data) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}/sensitive`, {
        ...data,
    });
};
